export const environment = {
  production: false,
  baseUrl: 'https://as-ws-siteitfoods-prod.azurewebsites.net/api/',
  // baseUrl: 'https://sitefoodsback.com/api/', // PRODUCCION


  // baseUrl: 'https://as-ws-siteitfoods-pru.azurewebsites.net/api/', // pruebas viejo
  // baseUrl: 'https://siteitfood.org/api/', // KUBERNETE

  baseUrlSocket: 'https://as-ws-siteitfoods-pru.azurewebsites.net', // pruebas viejo
  // baseUrlSocket: 'https://siteitfood.org', // KUBERNETE

  endPointMicroApi: 'https://as-manager-ecommerce-and-web.azurewebsites.net/micro-api',

  // Amplitude
  trackEventAmplitude: true,
  // apiKeyAmplitude: 'a218656fa55b2efc3ef446ca6372df25', // pruebas 
  apiKeyAmplitude: '833deebc1f05137d48b031345e1d43a0',
};
